import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PendReasonViewer from './PendReasonViewer';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    setCommitmentOrCertificateNumber,
    setLenderLoanNumber, setApplicationType,
    setStatus, setStatusMessage,
    setReceivedDate, setReceivedTime,
    setPendedReasons, setSuspendReason
} from "../actions/redux/setLoanStatusDetails";
import { UploadDocumentsUrl } from '../actions/api/APICalls';

var FA = require('react-fontawesome');

const formatDateTime = (dateString) => {
    const dt = new Date(dateString);
    const t = dt.toLocaleTimeString();
    return `${(dt.getMonth() + 1).toString().padStart(2, 0)}/${dt.getDate().toString().padStart(2,0)}/${dt.getFullYear()} ${dt.getHours().toString().padStart(2, 0)}:${dt.getMinutes().toString().padStart(2,0)} ${t.substring(t.lastIndexOf(' '))}`
}

const formatDate = (dateString) => {
    let dt = dateString;
    if (dt !== "") {
        const yyyy = dt.substr(0, 4);
        const mm = parseInt(dt.substr(4, 2));
        const dd = parseInt(dt.substr(6, 2));
        dt = "" + mm + "/" + dd + "/" + yyyy;
    }
    return dt;
}

const formatTime = (timeString) => {
    let tt = timeString;
    if (tt !== "") {
        let h = parseInt(tt.substr(0, 2));
        const mi = tt.substr(3, 2);
        let s = "AM";
        if (h == 0) {
            h = 12;
        }
        else if (h == 12){
            s = "PM";
        }
        else if (h > 12) {
            s = "PM";
            h = h - 12;
        }
        //const ss = tt.substr(6, 2);
        tt = "" + h + ":" + mi + " " + s + " EST";
    }
    return tt;
}

function LoanResult() {
    const [showPendReasonViewer, setShowPendReasonViewer] = useState(false);
    const [currentPendReason, setCurrentPendReason] = useState(0);

    const dispatch = useDispatch();
    const messages = useSelector(store => store.messages);
    const result = useSelector(store => store.loanStatus);

    useEffect(() => {
        //Runs on the first render
        //And any time any dependency value changes
    }, [result]);

    const handleViewPendReasonBtnClick = (e) => {
        var index = parseInt(e.target.getAttribute("data-id"));
        setCurrentPendReason(index);
        setShowPendReasonViewer(true);
    }

    const handleClosePendReasonViewer = () => {
        setShowPendReasonViewer(false);
    }

    const handleBackBtnClick = (e) => {
        dispatch(setCommitmentOrCertificateNumber(""));
        dispatch(setLenderLoanNumber(""));
        dispatch(setApplicationType(""));
        dispatch(setStatus(""));
        dispatch(setStatusMessage(""));
        dispatch(setReceivedDate(""));
        dispatch(setReceivedTime(""));
        dispatch(setSuspendReason(""));
        dispatch(setPendedReasons([]));
    }

    const translateStatus = () => {
        var displayStat = "";
        switch (result.status) {
            case "AE2": displayStat = "Expired"; break;
            case "AIP": displayStat = "In Process"; break;
            case "AP": displayStat = "Pended"; break;
            case "AR": displayStat = "Declined"; break;
            case "AV": displayStat = "Submission Error"; break;
            case "AW": displayStat = "Withdrawn"; break;
            case "CA": displayStat = "Certificate Active"; break;
            case "CC1": displayStat = "Closed Loan"; break;
            case "CC2": displayStat = "Closed Loan"; break;
            case "CC3": displayStat = "Closed Loan"; break;
            case "CC4": displayStat = "Closed Loan"; break;
            case "CC5": displayStat = "Closed Loan"; break;
            case "CL": displayStat = "Closed Loan"; break;
            case "COMC": displayStat = "Cancelled"; break;
            case "COME": displayStat = "Expired"; break;
            case "COMS": displayStat = "Approved"; break;
            case "CT": displayStat = "Closed Loan"; break;
            case "CX": displayStat = "Closed Loan"; break;
            case "QA": displayStat = "Active"; break;
            case "QE": displayStat = "Expired"; break;
            default: displayStat = "Unknown"; break;
        }
        return displayStat;
    }

    const statusClass = () => {
        var className = "";
        switch (result.status) {
            case "AE2": className = "stopped"; break;
            case "AIP": className = "inproc"; break;
            case "AP": className = "pended"; break;
            case "AR": className = "stopped"; break;
            case "AV": className = "stopped"; break;
            case "AW": className = "stopped"; break;
            case "CA": className = "active"; break;
            case "CC1": className = "closed"; break;
            case "CC2": className = "closed"; break;
            case "CC3": className = "closed"; break;
            case "CC4": className = "closed"; break;
            case "CC5": className = "closed"; break;
            case "CL": className = "closed"; break;
            case "COMC": className = "stopped"; break;
            case "COME": className = "stopped"; break;
            case "COMS": className = "active"; break;
            case "CT": className = "closed"; break;
            case "CX": className = "closed"; break;
            case "QA": className = "active"; break;
            case "QE": className = "stopped"; break;
            default: className = "stopped"; break;
        }
        return "loan-stat-" + className;
    }

    const statusNote = () => {
        const msg_StatusNoteSubErrorDelegated = messages?.loanResult_StatusNoteSubErrorDelegated;
        const msg_StatusNoteSubErrorNonDelegated = messages?.loanResult_StatusNoteSubErrorNonDelegated;
        const msg_StatusNoteClosed = messages?.loanResult_StatusNoteClosed;

        var note = "";
        switch (result.status) {
            case "AE2": note = ""; break;
            case "AIP": note = ""; break;
            case "AP": note = ""; break;
            case "AR": note = ""; break;
            case "AV":
                if (result.applicationType === "Delegated")
                    note = msg_StatusNoteSubErrorDelegated;
                else if (result.applicationType === "Non Delegated")
                    note = msg_StatusNoteSubErrorNonDelegated;
                else
                    note = "";
                break;
            case "AW": note = ""; break;
            case "CA": note = ""; break;
            case "CC1":
            case "CC2":
            case "CC3":
            case "CC4":
            case "CC5":
            case "CL":
            case "CT":
            case "CX":
                note = msg_StatusNoteClosed;
                break;
            case "COMC": note = ""; break;
            case "COME": note = ""; break;
            case "COMS": note = ""; break;
            case "QA": note = ""; break;
            case "QE": note = ""; break;
            default: break;
        }
        return note;
    }

    const isNote = () => {
        return (statusNote() !== "");
    }

    const uploadDocuments = async () => {
        let upDocUrl = UploadDocumentsUrl(result.commitmentOrCertificateNumber ? result.commitmentOrCertificateNumber : null, result.lenderLoanNumber ? result.lenderLoanNumber : null);
        window.open(upDocUrl, "_blank");        
    }
    return (
        <div clssName="result-container statusContent">
            <PendReasonViewer
                isVisible={showPendReasonViewer}
                content={result.pendedReasons[currentPendReason]}
                onClose={handleClosePendReasonViewer} />
            <div className="row mt-3 mb-0">
                <div className="col-lg-12 text-start">
                    <button onClick={handleBackBtnClick} className="btn btn-sm btn-dark me-2 mb-2"><FA name="arrow-left" /> Back</button>
                </div>
            </div>
            <div className="card result-card">
                <div className="row">
                    <div className="col-lg-12">
                        <h3>Cert Status Results</h3>
                    </div>
                </div>
                <br />
                <div className="row">
                    <label className="col-lg-5 result-label">
                        Commitment or Certificate Number
                    </label>
                    <div className="col-lg-7 result-value">
                        <h4>{result.commitmentOrCertificateNumber ? result.commitmentOrCertificateNumber : "-"}</h4>
                    </div>
                </div>
                <div className="row">
                    <label className="col-lg-5 result-label">
                        Lender Loan Number
                    </label>
                    <div className="col-lg-7 result-value">
                        <h4>{result.lenderLoanNumber ? result.lenderLoanNumber : "-"}</h4>
                    </div>
                </div>
                <div className="row">
                    <label className="col-lg-5 result-label">
                        Application Type
                    </label>
                    <div className="col-lg-7 result-value">
                        <h4>{result.applicationType}</h4>
                    </div>
                </div>
                <div className="row mt-3">
                    <label className="col-lg-5 result-label">
                        Status
                    </label>
                    <div className="col-lg-7 result-value">
                        <h4>
                            <div className={"badge " + statusClass()}>{translateStatus()}</div>
                            &nbsp;
                            {(() => {
                                if (isNote()) {
                                    return <OverlayTrigger overlay={<Tooltip>{statusNote()}</Tooltip>}>
                                        <i data-bs-toggle="tooltip" className="small">
                                            <FA name="question-circle" />
                                        </i>
                                    </OverlayTrigger>;
                                }
                            })()}
                        </h4>
                    </div>
                </div>
                {result.pendedReasons.map((reason, index) =>
                    <div className="row" key={index}>
                        <label className="col-lg-5 result-label">
                            Pended Reason
                        </label>
                        <div className="col-lg-6 col-10 result-value truncate-ellipsis">
                            {reason}
                        </div>
                        <div className="col-lg-1 col-2 pt-1">
                            <button data-id={index} onClick={handleViewPendReasonBtnClick} className="btn btn-sm btn-secondary float-end">View</button>
                        </div>
                    </div>
                )}
                <div className="row">
                    <label className="col-lg-5 result-label">
                        Submission received date
                    </label>
                    <div className="col-lg-7 result-value">
                        {formatDate(result.receivedDate)}
                    </div>
                </div>
                <div className="row">
                    <label className="col-lg-5 result-label">
                        Submission received time
                    </label>
                    <div className="col-lg-7 result-value">
                        {formatTime(result.receivedTime)}
                    </div>
                </div>
                {(result.applicationType === 'Non Delegated') && result.lastDocReceivedDateTime &&
                    <>
                    <div className="row">
                        <label className="col-lg-5 result-label">
                            Most Recent Upload Received Date/Time
                        </label>
                        {result.lastDocReceivedDateTime && <div className="col-lg-7 result-value">
                            {result.lastDocReceivedDateTime}
                        </div>}
                    </div>
                    <div className="row upDocWrapper">
                        <button id="upload" class="upDocButton" onClick={uploadDocuments} >
                            Upload Documents
                        </button>
                    </div>
                    </>
                }
            </div>
        </div>
    );
}
export default LoanResult;

export {formatDate, formatTime, formatDateTime};